import type { Directive } from 'vue'

const prevent = (e: Event) => e.preventDefault()

export const vProtectedImage: Directive = {
  mounted(el: HTMLElement) {
    el.addEventListener('contextmenu', prevent)
    el.addEventListener('dragstart', prevent)
    el.setAttribute('draggable', 'false')
    el.style.setProperty('-webkit-touch-callout', 'none')
    el.style.setProperty('-webkit-user-select', 'none')
    el.style.userSelect = 'none'
  },
  unmounted(el: HTMLElement) {
    el.removeEventListener('contextmenu', prevent)
    el.removeEventListener('dragstart', prevent)
  }
}
